export * from './Kontact';

import { Kontact } from './Kontact';

export default Kontact;
